<template>
  <div class="virtual-account-container" @click.stop>
    <div class="current-type-container" @click="showPaymentSelecter = true">
      <span class="type-category">
        {{ changePriceFormat(curPrice) }}
        {{ curPayType ? curPayType.show_currency : '' }}
        <template v-if="!isGsOrSupPayAutoSelect">
          <span class="get-text" style="margin: 0 5px">=</span>

          {{ getProductName(curProduct) }}
          <template v-if="+curProduct.PRODUCT_EXTRA_COIN > 0">
            + {{ curProduct.PRODUCT_EXTRA_COIN }}
            {{ coinName }}
          </template>

          <template v-if="+curPrice.SUB_COIN > 0">
            +
            {{ curPrice.SUB_COIN }}
            {{ subCoinNama }}
          </template>

          <template v-if="+curPrice.EXTRA_COIN > 0">
            +
            {{ curPrice.EXTRA_COIN }}
            {{ extraCoinName }}
          </template>
        </template>
      </span>
      <Icon class="selected-type-icon"></Icon>
    </div>
    <PaymentSelecter
      v-if="showPaymentSelecter"
      @closeSelecter="showPaymentSelecter = false"
      :curPayType="curPayType"
      :curProduct="curProduct"
      :curPrice="curPrice"
      :pricesList="pricesList"
      v-bind:showChildSelector="showPaymentSelecter"
      @selectPayMent="selectPayMent"
      style="z-index: 1002"
    ></PaymentSelecter>
  </div>
</template>

<script>
import PaymentSelecter from '@components/officialStore/paytype/PaymentSelecter';
import { changePriceFormat } from '@utiles/officialStore';
import { mapGetters } from 'vuex';
import product from '@mixins/product';
import gsOperate from '@mixins/officialStore/gsOperate';
export default {
  name: 'Payment',
  mixins: [product, gsOperate],
  props: {
    curPayType: {
      require: true
    },
    languages: {
      require: true
    },
    curProduct: {
      require: true
    },
    pricesList: {
      require: true
    },
    curPrice: {
      require: true
    }
  },
  data() {
    return {
      showPaymentSelecter: false,
      originCoin: 0,
      extraCoin: 0,
      totalCoin: 0
    };
  },
  computed: {
    coinName() {
      return this.$store.state.coin_name;
    },
    ...mapGetters([
      'subCoinNama',
      'extraCoinName',
      'directPayCoinName',
      'directPayExtraCoinName'
    ])
  },
  watch: {
    curPrice: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.originCoin = +(newVal?.COIN || 0);
        this.extraCoin = +(newVal?.EXTRA_COIN || 0);
        this.totalCoin = this.originCoin + this.extraCoin;
      }
    }
  },
  methods: {
    changePriceFormat(price) {
      if (price !== undefined) {
        return changePriceFormat(price?.CURRENCY, price?.TRANS_AMOUNT);
      }
      return price && price?.TRANS_AMOUNT;
    },
    selectPrice(price) {
      this.curPrice = price;
      this.$nextTick(() => {
        this.showPaymentSelecter = false;
      });
    },
    selectPayMent(payment) {
      this.$emit('selectPayMent', payment);
      this.showPaymentSelecter = false;
    }
  },
  components: {
    PaymentSelecter
  }
};
</script>

<style lang="scss" scoped>
.virtual-account-container {
  display: block;
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  cursor: pointer;
}
.current-type-container {
  cursor: pointer;
  @psetbg ('child-channel-bg.png');
}
.selected-type-icon {
  cursor: pointer;
  @psetbg ('child-channel-ico.png');
}
</style>
